import { Directive, Input, OnDestroy, OnInit } from '@angular/core'
import { Observable, Subscription } from 'rxjs'
import { delay, filter, takeWhile } from 'rxjs/operators'
import { GbInfiniteScrollComponent } from 'libs/shared/utils/infinite-scroll/src'

/**
 * Trigger infinite scroll when not enough items to cause overflow
 * https://github.com/orizens/ngx-infinite-scroll/issues/207
 */
@Directive({
  selector: '[infiniteScrollTrigger]',
})
export class InfiniteScrollTriggerDirective implements OnInit, OnDestroy {
  @Input() items$!: Observable<any>
  itemsSub!: Subscription

  constructor(private host: GbInfiniteScrollComponent) {}

  ngOnInit(): void {
    this.itemsSub = this.items$
      .pipe(
        // ignore until we've loaded some items
        filter((items) => !!items && items.length > 0),
        // wait for container to re-render the new items list
        delay(1),
        // when the container overflows it'll complete immediately
        takeWhile(() => this.containerDoesNotOverflow()),
      )
      .subscribe(() => this.host.scrolled.emit())
  }

  ngOnDestroy(): void {
    this.itemsSub.unsubscribe()
  }

  containerDoesNotOverflow(): boolean {
    const container = document.querySelector('.mat-sidenav-content') || document.body
    return container.scrollHeight <= document.body.clientHeight
  }
}
